import React from "react";
import VisitasComponent from "../Components/Visitas";

const Visitas = () => {
    return <VisitasComponent />;
};

export default Visitas;